import React, { useEffect, useState , useCallback } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function AgenciesList() {
  const [agencies, setAgencies] = useState([]);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/agencies", { params: { limit: 50 } }); setAgencies(data.agencies); } catch (e) { console.warn("[AgenciesList.jsx] non-blocking error:", e); }
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="agencies-page">
      <div className="mb-10">
        <p className="text-overline">Premium</p>
        <h1 className="font-heading text-4xl sm:text-5xl text-white mt-2 font-light tracking-tight">Agencies</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {agencies.map((a) => (
          <Link key={a.id} to={`/agency/${a.id}`} className="card-luxe rounded-lg p-6 block">
            <div className="flex items-center justify-between mb-3">
              <span className="text-overline text-gold">{a.city}</span>
              {a.verification_level === "agency_verified" && (
                <span className="inline-flex items-center gap-1 text-[10px] text-emerald-300 border border-emerald/40 px-2 py-0.5 rounded-full">
                  <ShieldCheck className="w-3 h-3" /> Verified
                </span>
              )}
            </div>
            <h3 className="font-heading text-2xl text-white">{a.name}</h3>
            <p className="text-sm text-[#a3a3a3] mt-2 leading-relaxed">{a.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
